// blocky-slider-2.js
(() => {
  function initSlider(root) {
    const track = root.querySelector(".blocky-slider-2-carousel-track");
    const slides = Array.from(root.querySelectorAll(".blocky-image-video-slider-2-carousel-slide"));
    const btnPrev = root.querySelector(".left-arrow");
    const btnNext = root.querySelector(".right-arrow");
    const thumbs = Array.from(root.querySelectorAll(".blocky-slider-2-thumb"));

    if (!track || slides.length === 0) return;

    let index = 0;
    let slideWidth = 0;
    const slidesPerView = 3;

    function updateThumbs() {
      thumbs.forEach((t, i) => t.classList.toggle("active", i === index));
    }

    function compute() {
      slideWidth = slides[0].getBoundingClientRect().width;
      update();
    }

    function update() {
      const maxIndex = Math.max(0, slides.length - slidesPerView);
      index = Math.max(0, Math.min(index, maxIndex));

      track.style.transform = `translateX(-${index * slideWidth}px)`;

      btnPrev?.classList.toggle("disabled", index === 0);
      btnNext?.classList.toggle("disabled", index === maxIndex);

      updateThumbs();
    }

    btnPrev?.addEventListener("click", () => {
      if (index > 0) {
        index--;
        update();
      }
    });

    btnNext?.addEventListener("click", () => {
      if (index < slides.length - slidesPerView) {
        index++;
        update();
      }
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        index = parseInt(thumb.dataset.index, 10);
        update();
      });
    });

    window.addEventListener("resize", () => {
      clearTimeout(window.__bkyResize);
      window.__bkyResize = setTimeout(compute, 100);
    });

    compute();
  }

  document.querySelectorAll("blocky-slider-2").forEach(initSlider);
})();
